import React, { memo, useEffect } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { SubcontractorRequestsTable } from './subcontractor-requests-table/SubcontractorRequestsTable'
import { useDispatch } from 'react-redux'
import { FetchMCsWithPendingRequests } from 'src/constants/actionTypes'

const SubcontractorRequestsComponent = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchMCsWithPendingRequests = async () => {
      dispatch(FetchMCsWithPendingRequests.request())
    }

    fetchMCsWithPendingRequests()
  }, [])

  return (
    <div>
      <div css={tw`flex flex-row items-center justify-between mb-6 gap-4`}>
        <Typography variant="h2" css={tw`mb-2`}>
          Requests
        </Typography>
      </div>
      <SubcontractorRequestsTable />
    </div>
  )
}

export const SubcontractorRequests = memo(SubcontractorRequestsComponent)
